import React from 'react'

export default function Section(props) {
    const { render } = props;
    return (
        render && props.children
    )
};